const defaultErrorMessage = (value: unknown): string =>
  `Unhandled discriminated union member: ${JSON.stringify(value)}`;

export const assertNever = (
  value: never,
  errorMessage: string | ((value: unknown) => string) = defaultErrorMessage,
): never => {
  const resolvedMessage =
    typeof errorMessage === "string" ? errorMessage : errorMessage(value);

  throw new Error(resolvedMessage);
};
